import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
	Table,
	Button,
	Dropdown,
	Menu,
	Modal,
	Tooltip,
	Space,
	Input,
	Select,
	DatePicker,
	Checkbox,
	Spin
} from 'antd';
import {
	MoreOutlined,
	CopyOutlined,
	FilterOutlined,
	MailOutlined,
	CalendarOutlined,
	CloseOutlined
} from '@ant-design/icons';
import { Link, useNavigate } from "react-router-dom";
import "./Timeline.css";
import apiEndpoints from "../../../API/apiEndpoints";
import apiCall from "../../../API/apiService";
// import { Schedule } from "@material-ui/icons";
import { toasty } from "../../../../Helper";
import { debounce } from "lodash";
import Pagination from '@mui/material/Pagination';
import EmailIcon from '@mui/icons-material/Email';
import moment from 'moment-timezone';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { MoreOutlined as AntMoreOutlined, CopyOutlined as AntCopyOutlined } from '@ant-design/icons';
import CancelIcon from '../../../assets/svgComponent/cancel.svg';
import SaveIcon from '../../../assets/svgComponent/save.svg';
import EmailReportIcon from '../../../assets/svgComponent/emailreport.svg';


const saveFilterState = (filters, isApplied) => {
	localStorage.setItem("interviewListFilters", JSON.stringify({
		filters,
		isFilterApplied: isApplied,
		statusFilter: filters.status || "",
		roleFilter: filters.role_name || "",
		scheduledDateTimeFrom: filters.scheduled_datetime_from || "",
		scheduledDateTimeTo: filters.scheduled_datetime_to || "",
		completedDateTimeFrom: filters.completed_datetime_from || "",
		completedDateTimeTo: filters.completed_datetime_to || "",
		jobOpeningFilter: filters.jobopening_name || "",
		roundNoFilter: filters.round_no || "",
		organizationFilter: filters.organisation_name || ""
	}));
};

const loadFilterState = () => {
	const savedState = localStorage.getItem("interviewListFilters");
	return savedState ? JSON.parse(savedState) : {
		filters: {},
		isFilterApplied: false,
		statusFilter: "",
		roleFilter: "",
		scheduledDateTimeFrom: "",
		scheduledDateTimeTo: "",
		completedDateTimeFrom: "",
		completedDateTimeTo: "",
		jobOpeningFilter: "",
		roundNoFilter: "",
		organizationFilter: ""
	};
};

const InterviewTimeline = () => {
	const savedState = loadFilterState();
	const [scheduledDateTimeFrom, setScheduledDateTimeFrom] = useState(savedState.scheduledDateTimeFrom);
	const [scheduledDateTimeTo, setScheduledDateTimeTo] = useState(savedState.scheduledDateTimeTo);
	const [completedDateTimeFrom, setCompletedDateTimeFrom] = useState(savedState.completedDateTimeFrom);
	const [completedDateTimeTo, setCompletedDateTimeTo] = useState(savedState.completedDateTimeTo);
	const [anchorEl, setAnchorEl] = useState(null);
	const [openDialog, setOpenDialog] = useState(false);
	const [selectedInterview, setSelectedInterview] = useState(null);
	const [page, setPage] = useState(1);
	const [rowsPerPage, setRowsPerPage] = useState(15);
	const [openFilterPopover, setOpenFilterPopover] = useState(false);
	const [isFilterApplied, setIsFilterApplied] = useState(savedState.isFilterApplied);
	const [interviewList, setInterviewList] = useState([]);
	const [openNoDataDialog, setOpenNoDataDialog] = useState(false);
	const [selectedApplicant, setSelectedApplicant] = useState();
	const navigate = useNavigate();
	const [statusFilter, setStatusFilter] = useState(savedState.statusFilter || []);
	const [roleFilter, setRoleFilter] = useState(savedState.roleFilter);
	const [loading, setLoading] = useState(false);
	const [roles, setRoles] = useState([]);
	const [filters, setFilters] = useState(savedState.filters);
	const [openRescheduleDialog, setOpenRescheduleDialog] = useState(false);
	const [rescheduleDate, setRescheduleDate] = useState("");
	const [rescheduleTime, setRescheduleTime] = useState("");
	const [interviewToReschedule, setInterviewToReschedule] = useState(null);
	const [rescheduleReason, setRescheduleReason] = useState("");
	const [pageSize, setPageSize] = useState(15);
	const [totalPages, setTotalPages] = useState(1);
	const [totalItems, setTotalItems] = useState(0);
	const [isLoading, setIsLoading] = useState(true);
	const [allRoles, setAllRoles] = useState([]);
	const [filteredRoles, setFilteredRoles] = useState([]);
	const [openExportDialog, setOpenExportDialog] = useState(false);
	const [exportData, setExportData] = useState({
		start_date: '',
		end_date: '',
		start_time: '',
		end_time: '',
		organisation_name: '',
		jobopening_name: '',
	});
	const [minScore, setMinScore] = useState("");
	const [maxScore, setMaxScore] = useState("");
	const [jobOpeningFilter, setJobOpeningFilter] = useState(savedState.jobOpeningFilter);
	const [roundNoFilter, setRoundNoFilter] = useState(savedState.roundNoFilter);
	const [allOrganizations, setAllOrganizations] = useState([]);
	const [organizationFilter, setOrganizationFilter] = useState(savedState.organizationFilter);
	const [searchQuery, setSearchQuery] = useState('');
	const [allJobOpenings, setAllJobOpenings] = useState([]);
	const [filteredJobOpenings, setFilteredJobOpenings] = useState([]);
	const [showQuestionSelector, setShowQuestionSelector] = useState(false);
	const [availableQuestions, setAvailableQuestions] = useState([]);
	const [selectedQuestions, setSelectedQuestions] = useState([]);
	const [isRescheduling, setIsRescheduling] = useState(false); // New state for loading

	const getUniqueRoles = (interviews) => {
		const uniqueRoles = [
			...new Set(interviews.map((interview) => interview.role_name)),
		];
		return uniqueRoles.sort((a, b) => a.localeCompare(b));
	};

	const fetchData = useCallback(async () => {
		setIsLoading(true);
		try {
			let url = `${apiEndpoints.JOB_INTERVIEW}?page=${page}&page_size=${pageSize}`;

			if (isFilterApplied) {
				const queryParams = new URLSearchParams();

				// Handle multiple status parameters
				if (filters.status && Array.isArray(filters.status)) {
					filters.status.forEach(status => {
						queryParams.append('status', status);
					});
				}
				
				if (filters.role_name) queryParams.append('role_name', filters.role_name.trim());
				if (filters.scheduled_datetime_from) queryParams.append('scheduled_datetime_from', filters.scheduled_datetime_from);
				if (filters.scheduled_datetime_to) queryParams.append('scheduled_datetime_to', filters.scheduled_datetime_to);
				if (filters.completed_datetime_from) queryParams.append('completed_datetime_from', filters.completed_datetime_from);
				if (filters.completed_datetime_to) queryParams.append('completed_datetime_to', filters.completed_datetime_to);
				if (filters.jobopening_name) queryParams.append('jobopening_name', filters.jobopening_name);
				if (filters.round_no) queryParams.append('round_no', filters.round_no);
				if (filters.organisation_name) queryParams.append('organisation_name', filters.organisation_name);
				if (filters.min_interviewee_score !== null && !isNaN(filters.min_interviewee_score)) {
					queryParams.append('min_interviewee_score', filters.min_interviewee_score);
				}
				if (filters.max_interviewee_score !== null && !isNaN(filters.max_interviewee_score)) {
					queryParams.append('max_interviewee_score', filters.max_interviewee_score);
				}

				queryParams.append('page', page.toString());
				queryParams.append('page_size', pageSize.toString());

				if (queryParams.toString()) {
					url = `${apiEndpoints.JOB_INTERVIEW}/filter?${queryParams.toString()}`;
				}
			}

			console.log('Fetching data with URL:', url);
			const response = await apiCall('GET', url);
			console.log('API Response:', response);

			if (response && Array.isArray(response.items)) {
				const formattedInterviews = response.items.map(interview => {
					// Find the scheduled time from status history
					let scheduledTimestamp = null;
					if (interview.status_history && Array.isArray(interview.status_history)) {
						const scheduledStatus = interview.status_history.find(
							status => status.status === "SCHEDULED"
						);
						if (scheduledStatus && scheduledStatus.timestamp) {
							scheduledTimestamp = scheduledStatus.timestamp;
						}
					}

					// Use created_at as fallback if no scheduled timestamp is found
					if (!scheduledTimestamp && interview.created_at) {
						scheduledTimestamp = interview.created_at;
					}

					// Format scheduled time
					let localDate = null;
					let localTime = null;
					if (scheduledTimestamp) {
						const utcDateTime = moment.utc(scheduledTimestamp);
						const localDateTime = utcDateTime.local();
						localDate = localDateTime.format('DD/MM/YYYY');
						localTime = localDateTime.format('HH:mm');
					}

					// Get completion time from status history
					let completionTime = null;
					let completionDate = null;
					if (interview.status_history && Array.isArray(interview.status_history)) {
						const completedStatus = interview.status_history.find(
							status => status.status === "COMPLETED"
						);
						if (completedStatus && completedStatus.timestamp) {
							const utcCompletionTime = moment.utc(completedStatus.timestamp);
							const localCompletionTime = utcCompletionTime.local();
							completionTime = localCompletionTime.format('HH:mm');
							completionDate = localCompletionTime.format('DD/MM/YYYY');
						}
					}

					return {
						...interview,
						localDate,
						localTime,
						completionTime,
						completionDate
					};
				});

				setInterviewList(formattedInterviews);
				setTotalItems(response.total);
				setTotalPages(Math.ceil(response.total / pageSize));
				setRoles(getUniqueRoles(formattedInterviews));
				setOpenNoDataDialog(formattedInterviews.length === 0);
			} else {
				console.error("Unexpected response format:", response);
				setInterviewList([]);
				setOpenNoDataDialog(true);
			}
		} catch (error) {
			console.error('Error in fetchData:', error);
			toasty("Error fetching data", "error");
		} finally {
			setIsLoading(false);
		}
	}, [filters, isFilterApplied, page, pageSize]);

	useEffect(() => {

	}, [page, pageSize, fetchData]);

	// Add a debug effect to log the filtered roles when they change
	useEffect(() => {
		console.log('Filtered roles updated:', filteredRoles);
	}, [filteredRoles]);

	// Fetch data on component mount


	const handleDialogClose = () => {

		setSelectedApplicant();
		setOpenDialog(false);
	};

	const handleChangePage = (newPage) => {
		if (newPage >= 1 && newPage <= Math.ceil(totalItems / pageSize)) {
			setPage(newPage);
		}
	};



	const handleMenuClick = (event, interview) => {
		setAnchorEl(event.currentTarget);
		setSelectedInterview(interview);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};



	const getStatusString = (statusObject) => {
		if (typeof statusObject === 'string') return statusObject;
		return statusObject?.status || 'Unknown';
	};

	const getStatusTimestamp = (statusObject) => {
		if (typeof statusObject === 'string') return null;
		return statusObject?.timestamp || null;
	};

	const handleFilterApply = () => {
		const formatDateTime = (dateTimeString) => {
			if (!dateTimeString) return null;
			return moment(dateTimeString).format('YYYY-MM-DDTHH:mm:ss');
		};

		const parsedMinScore = minScore !== "" ? parseInt(minScore) : null;
		const parsedMaxScore = maxScore !== "" ? parseInt(maxScore) : null;

		const trimmedOrganizationFilter = organizationFilter ? organizationFilter.trim() : null;

		const newFilters = {
			status: statusFilter.length > 0 ? statusFilter : null,
			role_name: roleFilter || null,
			scheduled_datetime_from: formatDateTime(scheduledDateTimeFrom),
			scheduled_datetime_to: formatDateTime(scheduledDateTimeTo),
				completed_datetime_from: formatDateTime(completedDateTimeFrom),
				completed_datetime_to: formatDateTime(completedDateTimeTo),
				min_interviewee_score: parsedMinScore,
				max_interviewee_score: parsedMaxScore,
				jobopening_name: jobOpeningFilter || null,
				round_no: roundNoFilter || null,
				organisation_name: trimmedOrganizationFilter
		};

		console.log('Applying filters:', newFilters);

		if (parsedMinScore !== null && parsedMaxScore !== null && parsedMaxScore < parsedMinScore) {
			toasty("Maximum score must be greater than or equal to minimum score", "error");
			return;
		}

		const hasActiveFilters = Object.entries(newFilters).some(([key, value]) => {
			if (key === 'status') {
				return Array.isArray(value) && value.length > 0;
			}
			if (key.includes('score')) {
				return value !== null && !isNaN(value);
			}
			return value !== null && value !== "";
		});

		setIsFilterApplied(hasActiveFilters);
		setFilters(newFilters);
		saveFilterState(newFilters, hasActiveFilters);
		setPage(1); // Reset to first page
		setOpenFilterPopover(false);
		
		// Force immediate data refresh
		fetchData();
	};

	const handleClearFilters = () => {
		const defaultFilters = {
			status: [],
			role_name: "",
			scheduled_datetime_from: "",
			scheduled_datetime_to: "",
			completed_datetime_from: "",
			completed_datetime_to: "",
				min_interviewee_score: "",
				max_interviewee_score: "",
				jobopening_name: "",
				round_no: "",
				organisation_name: ""
		};

		setScheduledDateTimeFrom("");
		setScheduledDateTimeTo("");
		setCompletedDateTimeFrom("");
		setCompletedDateTimeTo("");
		setStatusFilter([]);
		setRoleFilter("");
		setMinScore("");
		setMaxScore("");
		setIsFilterApplied(false);
		setOpenFilterPopover(false);
		setFilters(defaultFilters);
		localStorage.removeItem("interviewListFilters");
		setPage(1);
		setJobOpeningFilter("");
		setRoundNoFilter("");
		setOrganizationFilter("");
		fetchData();
	};

	const truncateText = (text, length = 18) => {
		return text.length > length ? text.substring(0, length) + "..." : text;
	};

	const handleCopy = (url) => {
		// If it's a Daily.co URL, extract just the interview ID
		if (url && url.includes('daily.co')) {
			const parts = url.split('/');
			const id = parts[parts.length - 1];
			const interviewUrl = `${process.env.REACT_APP_WEBSITE_URL}/start-interview/${id}`;
			navigator.clipboard.writeText(interviewUrl);
		} else {
			// For regular interview IDs
			const interviewUrl = `${process.env.REACT_APP_WEBSITE_URL}/start-interview/${url}`;
			navigator.clipboard.writeText(interviewUrl);
		}
		toasty("Link copied to clipboard!", "success");
	};

	// New function to handle copying phone interview links
	const handleCopyPhoneLink = (id, event) => {
		if (event) {
			event.stopPropagation();
		}
		const phoneInterviewUrl = `${process.env.REACT_APP_WEBSITE_URL}/start-phone-interview/${id}`;
		navigator.clipboard.writeText(phoneInterviewUrl);
		toasty("Phone interview link copied to clipboard!", "success");
	};

	const handleNoDataDialogClose = () => {
		setOpenNoDataDialog(false);
	};

	const handleSchedule = (applicant_id, id) => {
		navigate(
			`/candidate-details?applicant_id=${applicant_id}&job_opening_id=${id}`
		);
	};

	const createScheduleHandler = (applicant_id, id) => () => {
		console.log(applicant_id, "applicant_id");
		console.log(id, "interview_id");
		handleSchedule(applicant_id, id);
	};




	const capitalizeFirstLetter = (string) => {
		return string.charAt(0).toUpperCase() + string.slice(1);
	};

	const handleRescheduleInterview = async (interview) => {
		// Open a dialog to get new date and time
		const newDate = prompt("Enter new date (YYYY-MM-DD):", interview.date);
		const newTime = prompt("Enter new time (HH:MM):", interview.time);

		if (newDate && newTime) {
			try {
				const response = await apiCall(
					"post",
					apiEndpoints.RESCHEDULE_INTERVIEW,
					{
						applicant_id: interview.applicant_id,
						round_no: interview.round_no,
						new_date: newDate,
						new_time: newTime,
						interviewer: interview.interviewer,
					}
				);

				if (response) {
					toasty("Interview rescheduled successfully!", "success");
					fetchData(); // Refresh the interview list
				}
			} catch (error) {
				console.error("Error rescheduling interview:", error);
				toasty("Failed to reschedule interview", "error");
			}
		}
	};

	// Optimize toggleQuestionSelection function for better performance
	const toggleQuestionSelection = (index) => {
		// Directly update state with optimized function
		setSelectedQuestions(prev => {
			// Check if index is already in the array
			const isSelected = prev.includes(index);
			// Return new array without creating intermediary arrays
			return isSelected 
				? prev.filter(i => i !== index) 
				: [...prev, index];
		});
	};

	// Updated handleRescheduleClick function
	const handleRescheduleClick = (interview) => {
		console.log("Interview data for reschedule:", interview);
		setInterviewToReschedule(interview);
		setRescheduleReason("");
		setSelectedQuestions([]);
		setShowQuestionSelector(false); // Start with questions hidden
		setAvailableQuestions([]); // Clear previous questions
		
		// Fetch questions from API
		const fetchQuestions = async () => {
			try {
				setIsLoading(true);
				// Call the new question bank API with jobopening_id and round_no
				const response = await apiCall(
					"GET", 
					`${apiEndpoints.QUESTION_BANK}/${interview.job_opening_id}/round/${interview.round_no}`
				);
				
				console.log("Question bank API response:", response);
				
				if (response && Array.isArray(response)) {
					// Map the questions with indexes for selection
					const questions = response.map((q, index) => ({
						...q,
						index
					}));
					
					console.log("Prepared questions for selection:", questions);
					setAvailableQuestions(questions);
				} else {
					console.log("No questions available or invalid response format");
					setAvailableQuestions([]);
				}
			} catch (error) {
				console.error("Error fetching question bank:", error);
				toasty("Failed to load questions for this interview", "error");
				setAvailableQuestions([]);
			} finally {
				setIsLoading(false);
			}
		};
		
		// Call the function to fetch questions
		fetchQuestions();
		
		setOpenRescheduleDialog(true);
	};

	const isValidDate = (dateString) => {
		return !isNaN(new Date(dateString).getTime());
	};

	const isValidTime = (timeString) => {
		return /^([01]\d|2[0-3]):([0-5]\d)$/.test(timeString);
	};

	const handleRescheduleSubmit = async () => {
		if (interviewToReschedule && rescheduleReason) {
			setIsRescheduling(true); // Start loading
			try {
				const payload = {
					jobinterview_id: interviewToReschedule.id,
					reschedule_reason: rescheduleReason,
					questions_index: selectedQuestions
				};

				console.log("Rescheduling interview with payload:", payload);

				const response = await apiCall(
					apiEndpoints.RESCHEDULE_INTERVIEW.method,
					apiEndpoints.RESCHEDULE_INTERVIEW.url,
					payload
				);

				console.log("Reschedule API response:", response);

				if (response && (response.success || response.id)) {
					toasty("Interview rescheduled successfully!", "success");
					await fetchData(); // Refresh the interview list
					setOpenRescheduleDialog(false);
					// Clear the reschedule form
					setRescheduleReason("");
					setInterviewToReschedule(null);
					setSelectedQuestions([]);
				} else {
					throw new Error(response.message || "Unexpected response format");
				}
			} catch (error) {
				console.error("Error rescheduling interview:", error);
				if (error.response) {
					toasty(`Failed to reschedule interview: ${error.response.data.detail || error.message}`, "error");
				} else {
					toasty(`Failed to reschedule interview: ${error.message}`, "error");
				}
			} finally {
				setIsRescheduling(false); // End loading
			}
		} else {
			toasty("Please fill in the reschedule reason", "error");
		}
	};

	const handleCopyId = (id, event) => {
		if (event) {
			event.stopPropagation();
		}
		navigator.clipboard.writeText(id);
		toasty("ID copied to clipboard!", "success");
	};

	const handlePageChange = (newPage) => {
		if (newPage >= 1 && newPage <= Math.ceil(totalItems / pageSize)) {
			setPage(newPage);
		}
	};



	const fetchAllOrganizations = useCallback(async () => {
		setIsLoading(true);
		try {
			// Change the API endpoint to the organization_summary endpoint
			const response = await apiCall('GET', apiEndpoints.ORGANIZATION_SUMMARY);
			console.log("Received organizations response:", response);

			if (Array.isArray(response)) {
				// Store full organization objects with ID and name
				const organizations = response
					.filter(org => org.name)
					.map(org => ({
						id: org._id || org.id,
						name: org.name
					}));
				console.log("Extracted organizations:", organizations);
				setAllOrganizations(organizations.sort((a, b) => a.name.localeCompare(b.name)));
			} else {
				console.error("Unexpected organizations response format:", response);
				setAllOrganizations([]);
			}
		} catch (error) {
			console.error("Error fetching organizations:", error);
			setAllOrganizations([]);
		} finally {
			setIsLoading(false);
		}
	}, []);

	// Add function to fetch job openings
	const fetchJobOpenings = useCallback(async () => {
		setIsLoading(true);
		try {
			// Construct query parameters if organization is selected
			let url = apiEndpoints.JOB_OPENING;
			if (organizationFilter) {
				url = `${url}?organisation_name=${encodeURIComponent(organizationFilter)}`;
			}
			
			console.log("Fetching job openings with URL:", url);
			const response = await apiCall('GET', url);
			
			if (response && Array.isArray(response.items)) {
				console.log("Job openings response:", response);
				// Extract unique job opening names
				const jobOpenings = response.items
					.filter(job => job.jobopening_name || job.name)
					.map(job => job.jobopening_name || job.name);
				
				// Remove duplicates and sort alphabetically
				const uniqueJobOpenings = [...new Set(jobOpenings)].sort((a, b) => 
					a.localeCompare(b)
				);
				
				console.log("Extracted job openings:", uniqueJobOpenings);
				setAllJobOpenings(uniqueJobOpenings);
				setFilteredJobOpenings(uniqueJobOpenings);
			} else {
				console.error("Unexpected job openings response format:", response);
				setAllJobOpenings([]);
				setFilteredJobOpenings([]);
			}
		} catch (error) {
			console.error("Error fetching job openings:", error);
			setAllJobOpenings([]);
			setFilteredJobOpenings([]);
		} finally {
			setIsLoading(false);
		}
	}, [organizationFilter]);

	// Add a debug function to compare API response with dropdown
	const debugRoleDropdown = (apiRoleNames, filteredRolesList) => {
		console.log("=== ROLE DROPDOWN DEBUG ===");
		console.log("Total roles from API:", apiRoleNames.length);
		console.log("Total roles in dropdown:", filteredRolesList.length);

		// Find roles that are in API but missing from dropdown
		const missingRoles = apiRoleNames.filter(role => !filteredRolesList.includes(role));
		if (missingRoles.length > 0) {
			console.log("Roles in API but missing from dropdown:", missingRoles);
		} else {
			console.log("All API roles are present in dropdown");
		}

		// Find roles that are in dropdown but not in API
		const extraRoles = filteredRolesList.filter(role => !apiRoleNames.includes(role));
		if (extraRoles.length > 0) {
			console.log("Roles in dropdown but not in API:", extraRoles);
		} else {
			console.log("No extra roles in dropdown");
		}
		console.log("=== END DEBUG ===");
	};

	// Replace fetchAllRoles with this updated function
	const fetchRolesByOrg = useCallback(async (orgId, deptId, subDeptId) => {
		if (!orgId) return;

		setIsLoading(true);
		try {
			// Use the specific API endpoint format from the user's requirements
			let url = `${apiEndpoints.ROLE_SUMMARY}?org_id=${orgId}`;

			// Add department and subdepartment parameters if available
			if (deptId) url += `&department_id=${deptId}`;
			if (subDeptId) url += `&subdepartment_id=${subDeptId}`;

			console.log("Fetching roles with URL:", url);
			let response = await apiCall('GET', url);
			console.log("Received roles response:", response);
			// Log full response structure to inspect the data
			console.log("Full response structure:", JSON.stringify(response, null, 2));

			// Handle different response formats
			let roleNames = [];
			let uniqueRoles = [];

			// Handle different response formats
			if (response?.items && Array.isArray(response.items)) {
				// Format 1: Response with items array
				console.log("Processing response with items array, length:", response.items.length);

				// Expanded list of possible field names for roles
				roleNames = response.items
					.map(role => {
						// Log each item to see its structure
						console.log("Role item:", role);
						return role.name || role.role_name || role.title || role.roleName ||
							role.role || role.designation || role.position;
					})
					.filter(Boolean);
				console.log("Extracted role names from items:", roleNames);
			} else if (Array.isArray(response)) {
				// Format 2: Direct array response
				console.log("Processing direct array response, length:", response.length);

				// Try to determine the structure by checking the first item
				const firstItem = response[0];
				console.log("First item in array:", firstItem);

				if (firstItem && typeof firstItem === 'object') {
					// Object array - extract name field with expanded field list
					roleNames = response
						.map(role => {
							// Log each role to see what fields are available
							console.log("Processing role object:", role);
							return role.name || role.role_name || role.title || role.roleName ||
								role.role || role.designation || role.position;
						})
						.filter(Boolean);
					console.log("Extracted role names from objects:", roleNames);
				} else if (typeof firstItem === 'string') {
					// String array - use directly
					roleNames = response.filter(Boolean);
					console.log("Using string array directly:", roleNames);
				}
			} else if (response && typeof response === 'object') {
				// Format 3: Other object response - try to find arrays or direct fields
				console.log("Processing object response with keys:", Object.keys(response));

				// First look for a direct 'results' or 'data' property
				if (response.results && Array.isArray(response.results)) {
					console.log("Found results array with length:", response.results.length);
					const resultsRoles = response.results
						.map(item => item.name || item.role_name || item.title || item.roleName ||
							item.role || item.designation || item.position)
						.filter(Boolean);
					console.log("Extracted roles from results:", resultsRoles);
					roleNames = [...roleNames, ...resultsRoles];
				}

				// Log each key to find potential role arrays
				Object.keys(response).forEach(key => {
					console.log(`Key ${key} is of type: ${typeof response[key]}`);
					if (Array.isArray(response[key])) {
						console.log(`Found array in ${key} property with ${response[key].length} items`);
						// Log the first few items
						console.log(`Sample items from ${key}:`, response[key].slice(0, 3));

						const namesFromProperty = response[key]
							.map(item => {
								if (typeof item === 'object') {
									console.log("Object item from array:", item);
									return item.name || item.role_name || item.title || item.roleName ||
										item.role || item.designation || item.position;
								}
								return typeof item === 'string' ? item : null;
							})
							.filter(Boolean);

						if (namesFromProperty.length > 0) {
							console.log(`Found ${namesFromProperty.length} role names in ${key} property:`, namesFromProperty);
							roleNames = [...roleNames, ...namesFromProperty];
						}
					}
				});
			}

			// Check if we have a special nested structure that's common in some APIs
			if (response?.data?.roles && Array.isArray(response.data.roles)) {
				console.log("Found nested roles array in data.roles with length:", response.data.roles.length);
				const nestedRoles = response.data.roles
					.map(role => role.name || role.role_name || role.title || role.roleName ||
						role.role || role.designation || role.position)
					.filter(Boolean);
				console.log("Extracted roles from nested data.roles:", nestedRoles);
				roleNames = [...roleNames, ...nestedRoles];
			}

			// Check for roles field directly
			if (response?.roles && Array.isArray(response.roles)) {
				console.log("Found roles array directly with length:", response.roles.length);
				const directRoles = response.roles
					.map(role => role.name || role.role_name || role.title || role.roleName ||
						role.role || role.designation || role.position)
					.filter(Boolean);
				console.log("Extracted roles from direct roles field:", directRoles);
				roleNames = [...roleNames, ...directRoles];
			}

			// If we still don't have roles, use the ones from existing interview data as a fallback
			if (roleNames.length === 0) {
				console.log("No roles found from API, using roles from existing interviews as fallback");
				roleNames = interviewList
					.filter(interview => interview.organisation_name ===
						allOrganizations.find(org => org.id === orgId)?.name)
					.map(interview => interview.role_name)
					.filter(Boolean);
			}

			// Save the original roles for debugging
			const originalRoleNames = [...roleNames];

			uniqueRoles = [...new Set(roleNames)].sort((a, b) => a.localeCompare(b));
			console.log(`Extracted ${uniqueRoles.length} unique roles from ${roleNames.length} total roles:`, uniqueRoles);
			setFilteredRoles(uniqueRoles);

			// Debug the difference between API roles and dropdown roles
			debugRoleDropdown(originalRoleNames, uniqueRoles);

			// If current role is not in the filtered list, reset it
			if (roleFilter && !uniqueRoles.includes(roleFilter)) {
				setRoleFilter("");
			}
		} catch (error) {
			console.error("Error fetching roles for organization:", error);

			// Fallback to roles from existing interviews
			console.log("Error fetching roles, using existing interview roles as fallback");
			const selectedOrgName = allOrganizations.find(org => org.id === orgId)?.name;
			const roleNames = interviewList
				.filter(interview => interview.organisation_name === selectedOrgName)
				.map(interview => interview.role_name)
				.filter(Boolean);

			const uniqueRoles = [...new Set(roleNames)].sort((a, b) => a.localeCompare(b));
			console.log(`Extracted ${uniqueRoles.length} roles from fallback:`, uniqueRoles);
			setFilteredRoles(uniqueRoles);
		} finally {
			setIsLoading(false);
		}
	}, [roleFilter, interviewList, allOrganizations]);

	// Modify the handleOrganizationChange function
	const handleOrganizationChange = (value) => {
		console.log("Organization changed to:", value);
		setOrganizationFilter(value);

		// Clear role filter and roles when organization is cleared or changed
		setRoleFilter("");
		setFilteredRoles([]);
		setJobOpeningFilter(""); // Clear job opening filter when organization changes

		if (value) {
			// Find org ID and fetch roles
			const orgObj = allOrganizations.find(org => org.name === value);
			if (orgObj && orgObj.id) {
				console.log("Fetching roles for organization ID:", orgObj.id);
				fetchRolesByOrg(orgObj.id);
			} else {
				console.error("Could not find organization with name:", value);
				setFilteredRoles([]);
			}
		}
	};

	// Modify the updateFilteredRoles function
	const updateFilteredRoles = useCallback((selectedOrg) => {
		if (!selectedOrg) {
			setFilteredRoles([]);
			return;
		}

		// Find the organization ID based on the selected organization name
		const selectedOrgObj = allOrganizations.find(org => org.name === selectedOrg);
		if (selectedOrgObj && selectedOrgObj.id) {
			console.log("Found organization ID for", selectedOrg, ":", selectedOrgObj.id);
			fetchRolesByOrg(selectedOrgObj.id);
		} else {
			console.error("Could not find organization ID for:", selectedOrg);
			setFilteredRoles([]);
		}
	}, [allOrganizations, fetchRolesByOrg]);

	// Update useEffects to only load organizations when filter button is clicked

	console.log('Current allRoles:', allRoles); // Add this line for debugging

	const handleExportDialogOpen = () => {
		// Only fetch job openings when the export dialog is opened
		
		setOpenExportDialog(true);
	};

	const handleExportDialogClose = () => {
		setOpenExportDialog(false);
	};

	

	const handleExportDataChange = (field) => (value) => {
		if (field === 'start_time' || field === 'end_time') {
			// Convert local time to UTC for time inputs
			const localTime = moment(value, 'HH:mm');
			value = localTime.utc().format('HH:mm:ss');
		}
		setExportData({ ...exportData, [field]: value });
	};

	const handleExportSubmit = async () => {
		try {
			const payload = { ...exportData };

			// Remove start_time and end_time if they are empty strings
			Object.keys(payload).forEach((key) => {
				if (payload[key] === '') delete payload[key];
			});

			// Ensure dates are in YYYY-MM-DD format
			if (payload.start_date) payload.start_date = moment(payload.start_date).format('YYYY-MM-DD');
			if (payload.end_date) payload.end_date = moment(payload.end_date).format('YYYY-MM-DD');

			const response = await apiCall(
				apiEndpoints.EXPORT_JOB_INTERVIEWS.method,
				apiEndpoints.EXPORT_JOB_INTERVIEWS.url,
				payload
			);

			// Handle different successful response formats
			if (response) {
				if (typeof response === 'string') {
					toasty(response, "success");
				} else if (response.message) {
					toasty(response.message, "success");
				} else if (response.detail) {
					toasty(response.detail, "success");
				} else {
					toasty("Export request sent successfully!", "success");
				}
				handleExportDialogClose();
			}
		} catch (error) {
			console.error("Error sending export request:", error);
			if (error.response?.data?.detail === "No job interviews found for the given date range") {
				toasty("No interviews match your criteria. Please try a broader search.", "warning");
			} else {
				// Your existing error handling code
				const errorMessages = Array.isArray(error.response?.data?.detail)
					? error.response.data.detail.map(err => err.msg).join(', ')
					: error.response?.data?.detail || error.message;
				toasty(`Failed to send export request: ${errorMessages}`, "error");
			}
		}
	};

	const columns = [
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>ID</span>,
			dataIndex: 'id',
			key: 'id',
			render: (text) => (
				<Space>
					<span style={{ color: "#27272A", fontSize: 11 }}>
						{text ? text.slice(-10) : 'N/A'}
					</span>
					<Tooltip title="Copy ID">
						<Button
							icon={<AntCopyOutlined />}
							size="small"
							onClick={(e) => handleCopyId(text, e)}
						/>
					</Tooltip>
				</Space>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Scheduled Time</span>,
			key: 'scheduledTime',
			render: (record) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{record.localDate && record.localTime ?
						`${record.localDate} ${record.localTime}` :
						'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Completion Time</span>,
			key: 'completion',
			render: (record) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{record.completionDate && record.completionTime ?
						`${record.completionDate} ${record.completionTime}` :
						'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Organization</span>,
			dataIndex: 'organisation_name',
			key: 'organisation_name',
			render: (text) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{text || 'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Round name</span>,
			dataIndex: 'round_name',
			key: 'round_name',
			render: (text) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{text || 'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Applicant Name</span>,
			dataIndex: 'candidate_name',
			key: 'candidate_name',
			render: (text) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{text || 'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Role</span>,
			dataIndex: 'role_name',
			key: 'role_name',
			render: (text) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{text || 'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Job Opening</span>,
			dataIndex: 'jobopening_name',
			key: 'jobopening_name',
			render: (text) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{text || 'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Round</span>,
			dataIndex: 'round_no',
			key: 'round_no',
			render: (text) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{text || 'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Status</span>,
			dataIndex: 'status',
			key: 'status',
			render: (text) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{getStatusString(text) || 'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Interviewee Score</span>,
			dataIndex: ['feedback'],
			key: 'score',
			render: (feedback) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{feedback && feedback.interviewee_score !== undefined && feedback.total_score !== undefined
						? `${feedback.interviewee_score}/${feedback.total_score}`
						: 'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Candidate Feedback</span>,
			dataIndex: 'candidate_remark',
			key: 'candidate_remark',
			render: (candidate_remark) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{candidate_remark ? `${candidate_remark.Overall}/${5}`
						: 'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Interviewers</span>,
			dataIndex: 'interviewer',
			key: 'interviewer',
			render: (interviewers) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{Array.isArray(interviewers) ? interviewers.join(', ') : 'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Interview Link</span>,
			dataIndex: 'room_url',
			key: 'room_url',
			render: (url, record) => (
				<Space>
					<Button
						type=""
						style={{ borderRadius: 4 }}
						onClick={(e) => {
							e.stopPropagation();
							handleCopy(record.id);
						}}
					>
						Copy
					</Button>
					<Button
						type=""
						style={{ borderRadius: 4 }}
						onClick={(e) => {
							e.stopPropagation();
							handleCopyPhoneLink(record.id, e);
						}}
					>
						Copy Phone
					</Button>
				</Space>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>cheating status</span>,
			key: 'cheated',
			render: (record) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{record.feedback && record.cheated !== null ? 
						record.cheated ? 'Yes' : 'No' : 
						'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Interview Issue</span>,
			key: 'interview_issue',
			render: (record) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{record.feedback && record.interview_issue !== null ? 
						(typeof record.interview_issue === 'object' && record.interview_issue.issue
							? record.interview_issue.issue
							: record.interview_issue) : 'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Questions Answered</span>,
			key: 'questions_answered',
			render: (record) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{record.feedback && record.feedback.questions_answered !== undefined ? 
						record.feedback.questions_answered : 
						'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Questions Asked</span>,
			key: 'questions_asked',
			render: (record) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{record.feedback && record.feedback.questions_asked !== undefined ? 
						record.feedback.questions_asked : 
						'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Total Questions</span>,
			key: 'total_questions',
			render: (record) => (
				<span style={{ color: "#27272A", fontSize: 11 }}>
					{record.feedback && record.feedback.total_questions !== undefined ? 
						record.feedback.total_questions : 
						'N/A'}
				</span>
			),
		},
		{
			title: <span style={{ color: "#27272A", fontSize: 11, fontWeight: '500' }}>Actions</span>,
			key: 'actions',
			render: (_, record) => (
				<Dropdown
					overlay={
						<Menu onClick={(e) => e.domEvent.stopPropagation()}>
							<Menu.Item onClick={(e) => {
								e.domEvent.stopPropagation();
								handleRescheduleClick(record);
							}}>
								Reschedule
							</Menu.Item>
							<Menu.Item onClick={(e) => {
								e.domEvent.stopPropagation();
								handleCopy(record.id);
							}}>
								Copy Link
							</Menu.Item>
						</Menu>
					}
					trigger={["click"]}
				>
					<Button
						icon={<MoreOutlined />}
						onClick={(e) => e.stopPropagation()}
					/>
				</Dropdown>
			),
		},
	];



	const filterContent = () => (
		<div style={{
			width: "410px",
			height: "95vh",
			fontFamily: "inter",
			padding: "0",
			borderRadius: "12px",
			backgroundColor: "#FFFFFF",
			position: "fixed",
			right: "12px",
			top: "12px",
			display: "flex",
			flexDirection: "column",
			boxShadow: `
				0px 20px 44px 0px rgba(0, 0, 0, 0.1),
				0px 80px 80px 0px rgba(0, 0, 0, 0.09),
				0px 180px 108px 0px rgba(0, 0, 0, 0.05),
				0px 319px 128px 0px rgba(0, 0, 0, 0.01),
				0px 499px 140px 0px rgba(0, 0, 0, 0)
			`
		}}>
			<div style={{
				width: "100%",
				height: "40px",
				padding: "8px 16px",
				borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				background: "rgba(247, 247, 248, 1)",
				flexShrink: 0,
				borderRadius: "12px 12px 0 0"
			}}>
				<div style={{
					display: "flex",
					alignItems: "center",
					gap: "8px",  // Increased gap for better spacing
					marginLeft: "8px" // Added left margin
				}}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						color="lightblue"
						viewBox="0 0 16 16"
						fill="none"
						style={{ flexShrink: 0 }} // Prevents icon from shrinking
					>
						<path
							d="M2 4h12M4 8h8M6 12h4"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
					<span style={{
						fontWeight: "500",
						fontSize: "16px",
						color: "#27272A"
					}}>
						Filters
					</span>
				</div>
				<Button
					type="text"
					icon={<CloseOutlined />}
					onClick={() => setOpenFilterPopover(false)}
					style={{
						border: 'none',
						background: 'transparent',
						padding: '4px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						marginRight: "4px" // Reduced right margin
					}}
				/>
			</div>

			<div style={{
				padding: "24px 12px 24px 24px",
				flex: 1,
				overflowY: "auto",
				overflowX: "hidden"
			}}>
				<div style={{ marginBottom: "24px" }}>
					<div style={labelStyle}>Organization</div>
					<Select
						placeholder="Select Organization"
						value={organizationFilter}
						onChange={handleOrganizationChange}
						style={inputStyle}
						allowClear
					>
						<Select.Option value="" disabled>
							<span style={{ color: '#A9A9A9', fontSize: '14px' }}>choose from this list</span>
						</Select.Option>
						{allOrganizations.map(org => (
							<Select.Option key={org.id} value={org.name}>{org.name}</Select.Option>
						))}
					</Select>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<div style={labelStyle}>Status</div>
					<Select
						placeholder="Select Status"
						value={statusFilter}
						onChange={setStatusFilter}
						style={inputStyle}
						mode="multiple"
						allowClear
					>
						<Select.Option value="SCHEDULED">Scheduled</Select.Option>
						<Select.Option value="STARTED">Started</Select.Option>
						<Select.Option value="COMPLETED">Completed</Select.Option>
						<Select.Option value="CANCELED">Canceled</Select.Option>
						<Select.Option value="RESCHEDULED">Rescheduled</Select.Option>
						<Select.Option value="VERIFIED">Verified</Select.Option>
						<Select.Option value="CHEATED">Cheated</Select.Option>
						<Select.Option value="TECH_ISSUE">Tech Issue</Select.Option>
						<Select.Option value="PASSED">Passed</Select.Option>
						<Select.Option value="TEST_INTERVIEW">Test Interview</Select.Option>
						<Select.Option value="REJECTED">Rejected</Select.Option>
						<Select.Option value="NOT_INTERESTED">Not Interested</Select.Option>
						<Select.Option value="COMPANY_REJECTED">Company Rejected</Select.Option>
						<Select.Option value="FORWARDED_TO_CLIENT">Forwarded to Client</Select.Option>
						<Select.Option value="CLIENT_SHORTLISTED">Client Shortlisted</Select.Option>
						<Select.Option value="CLIENT_REJECTED">Client Rejected</Select.Option>
						<Select.Option value="OFFER_ROLLED_OUT">Offer Rolled Out</Select.Option>
						<Select.Option value="OFFER_ACCEPTED">Offer Accepted</Select.Option>
						<Select.Option value="OFFER_REJECTED_BY_CANDIDATE">Offer Rejected by Candidate</Select.Option>
						<Select.Option value="JOINED">Joined</Select.Option>
						<Select.Option value="NOT_JOINED">Not Joined</Select.Option>
						<Select.Option value="ON_HOLD">On Hold</Select.Option>
						<Select.Option value="DROPPED_OUT">Dropped Out</Select.Option>
					</Select>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<div style={labelStyle}>Role</div>
					<Select
						placeholder={organizationFilter ? "Select Role" : "Please select an organization first"}
						value={roleFilter}
						onChange={setRoleFilter}
						style={inputStyle}
						allowClear
						disabled={!organizationFilter}
						loading={isLoading && organizationFilter}
						showSearch
						optionFilterProp="children"
						filterOption={(input, option) =>
							(option?.children || '').toLowerCase().includes(input.toLowerCase())
						}
						dropdownRender={menu => (
							<div>
								{menu}
								<div style={{ textAlign: 'center', padding: '8px', borderTop: '1px solid #e8e8e8' }}>
									<div style={{ color: '#999' }}>
										{filteredRoles.length === 0 ?
											'No roles found for this organization' :
											`${filteredRoles.length} roles available`}
									</div>
								</div>
							</div>
						)}
					>
						<Select.Option value="" disabled>
							<span style={{ color: '#A9A9A9', fontSize: '14px' }}>
								{organizationFilter ? "choose from this list" : "select an organization first"}
							</span>
						</Select.Option>
						{filteredRoles.map(role => (
							<Select.Option key={role} value={role}>{role}</Select.Option>
						))}
					</Select>
					{filteredRoles.length > 0 && (
						<div style={{ marginTop: '5px', fontSize: '12px', color: '#666' }}>
							{`${filteredRoles.length} roles available`}
						</div>
					)}
				</div>

				<div style={{ marginBottom: "24px" }}>
					<div style={labelStyle}>Job Opening</div>
					<Select
						placeholder="Select Job Opening"
						value={jobOpeningFilter}
						onChange={handleJobOpeningChange}
						style={inputStyle}
						allowClear
						loading={isLoading}
						showSearch
						optionFilterProp="children"
						filterOption={(input, option) =>
							(option?.children || '').toLowerCase().includes(input.toLowerCase())
						}
					>
						<Select.Option value="" disabled>
							<span style={{ color: '#A9A9A9', fontSize: '14px' }}>choose from this list</span>
						</Select.Option>
						{filteredJobOpenings.map(job => (
							<Select.Option key={job} value={job}>{job}</Select.Option>
						))}
					</Select>
					{filteredJobOpenings.length > 0 && (
						<div style={{ marginTop: '5px', fontSize: '12px', color: '#666' }}>
							{`${filteredJobOpenings.length} job openings available`}
						</div>
					)}
				</div>

				<div style={{ marginBottom: "24px" }}>
					<div style={labelStyle}>Scheduled Date & Time Range</div>
					<Space direction="vertical" style={{ width: '100%' }}>
						<DatePicker
							placeholder="From Date"
							value={scheduledDateTimeFrom ? moment(scheduledDateTimeFrom).startOf('day') : null} // Set to start of the day
							onChange={(date) => setScheduledDateTimeFrom(date ? date.format('YYYY-MM-DD 00:00') : null)} // Set default time to 00:00
							style={inputStyle}
							format="YYYY-MM-DD" // Remove time format
						/>
						<DatePicker
							placeholder="To Date"
							value={scheduledDateTimeTo ? moment(scheduledDateTimeTo).startOf('day') : null} // Set to start of the day
							onChange={(date) => setScheduledDateTimeTo(date ? date.format('YYYY-MM-DD 00:00') : null)} // Set default time to 00:00
							style={inputStyle}
							format="YYYY-MM-DD" // Remove time format
						/>
					</Space>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<div style={labelStyle}>Completed Date & Time Range</div>
					<Space direction="vertical" style={{ width: '100%' }}>
						<DatePicker
							placeholder="From Date"
							value={completedDateTimeFrom ? moment(completedDateTimeFrom).startOf('day') : null} // Set to start of the day
							onChange={(date) => setCompletedDateTimeFrom(date ? date.format('YYYY-MM-DD 00:00') : null)} // Set default time to 00:00
							style={inputStyle}
							format="YYYY-MM-DD" // Remove time format
						/>
						<DatePicker
							placeholder="To Date"
							value={completedDateTimeTo ? moment(completedDateTimeTo).startOf('day') : null} // Set to start of the day
							onChange={(date) => setCompletedDateTimeTo(date ? date.format('YYYY-MM-DD 00:00') : null)} // Set default time to 00:00
							style={inputStyle}
							format="YYYY-MM-DD" // Remove time format
						/>
					</Space>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<div style={labelStyle}>Score Range</div>
					<Space>
						<Input
							placeholder="Min Score"
							name="Min Score"
							value={minScore}
							onChange={(e) => setMinScore(e.target.value)}
							type="number"
							style={{ ...inputStyle, width: "120px" }}
						/>
						<Input
							placeholder="Max Score"
							value={maxScore}
							onChange={(e) => setMaxScore(e.target.value)}
							type="number"
							style={{ ...inputStyle, width: "120px" }}
						/>
					</Space>
				</div>

				<div style={{ marginBottom: "24px" }}>
					<div style={labelStyle}>Round Number</div>
					<Input
						placeholder="Enter Round Number"
						value={roundNoFilter}
						onChange={(e) => setRoundNoFilter(e.target.value)}
						type="number"
						style={inputStyle}
					/>
				</div>
			</div>

			<div style={{
				width: "100%",
				height: "80px",
				display: "flex",
				gap: "10px",
				padding: "16px",
				background: "rgba(247, 247, 248, 1)",
				borderTop: "1px solid rgba(0, 0, 0, 0.1)",
				position: "sticky",
				borderRadius: "12px",
				bottom: 0,
				left: 0,
				right: 0,
				flexShrink: 0
			}}>
				<img
					src={CancelIcon}
					onClick={handleClearFilters}
					alt="Cancel"
					style={{
						width: "180px",
						height: "50px",
						objectFit: "contain",
						cursor: "pointer",
						transition: "transform 0.2s"
					}}
					onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.95)"}
					onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
					onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
				/>

				<img
					src={SaveIcon}
					onClick={handleFilterApply}
					alt="Save"
					style={{
						width: "180px",
						height: "48px",
						objectFit: "contain",
						cursor: "pointer",
						transition: "transform 0.2s"
					}}
					onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.95)"}
					onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
					onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
				/>
			</div>
		</div>
	);

	const inputStyle = {
		width: "368px",
		height: "34px",
		padding: "6px 10px",
		gap: "8px",
		borderRadius: "6px",
		border: "1px solid rgba(255, 255, 255, 1)",
		boxShadow: "0px 1px 2px 0px rgba(17, 24, 39, 0.08), 0px 0px 0px 1px rgba(17, 24, 39, 0.1)",
		backgroundColor: "#F3F4F6",
		fontSize: "14px",
		fontFamily: "Inter"
	};

	const labelStyle = {
		display: "block",
		fontSize: "14px",
		color: "#374151",
		marginBottom: "8px",
		fontWeight: "500"
	};

	const handleRowClick = (record) => {
		// Use the interview ID instead of job opening ID
		navigate(`/candidate-details?applicant_id=${record.applicant_id}&job_opening_id=${record.id}`);
	};

	// Add this style object at the top of the component
	const filterModalStyle = {
		position: 'fixed',
		top: 0,
		right: 0,
		width: '400px',
		height: '100vh',
		margin: 0,
		padding: 0,
		overflow: 'auto'
	};

	// Add debounced search function
	const debouncedSearch = useCallback(
		debounce(async (query) => {
			if (!query) {
				fetchData(); // Reset to normal data if search is empty
				return;
			}

			setIsLoading(true);
			try {
				// Add page_size parameter to the search URL
				const response = await apiCall('GET', `${apiEndpoints.JOB_INTERVIEW}/search?query=${query}&page=${page}&page_size=${pageSize}`);
				if (response && Array.isArray(response.items)) {
					const formattedInterviews = response.items.map(interview => {
						// Find the scheduled time from status history
						let scheduledTimestamp = null;
						if (interview.status_history && Array.isArray(interview.status_history)) {
							const scheduledStatus = interview.status_history.find(
								status => status.status === "SCHEDULED"
							);
							if (scheduledStatus && scheduledStatus.timestamp) {
								scheduledTimestamp = scheduledStatus.timestamp;
							}
						}

						// Use created_at as fallback if no scheduled timestamp is found
						if (!scheduledTimestamp && interview.created_at) {
							scheduledTimestamp = interview.created_at;
						}

						// Format scheduled time
						let localDate = null;
						let localTime = null;
						if (scheduledTimestamp) {
							const utcDateTime = moment.utc(scheduledTimestamp);
							const localDateTime = utcDateTime.local();
							localDate = localDateTime.format('DD/MM/YYYY');
							localTime = localDateTime.format('HH:mm');
						}

						// Get completion time from status history
						let completionTime = null;
						let completionDate = null;
						if (interview.status_history && Array.isArray(interview.status_history)) {
							const completedStatus = interview.status_history.find(
								status => status.status === "COMPLETED"
							);
							if (completedStatus && completedStatus.timestamp) {
								const utcCompletionTime = moment.utc(completedStatus.timestamp);
								const localCompletionTime = utcCompletionTime.local();
								completionTime = localCompletionTime.format('HH:mm');
								completionDate = localCompletionTime.format('DD/MM/YYYY');
							}
						}

						return {
							...interview,
							localDate,
							localTime,
							completionTime,
							completionDate
						};
					});
					setInterviewList(formattedInterviews);
					setTotalItems(response.total);
					setTotalPages(Math.ceil(response.total/pageSize));
				}
			} catch (error) {
				console.error('Error searching interviews:', error);
				toasty("Error searching interviews", "error");
			} finally {
				setIsLoading(false);
			}
		}, 300),
		[fetchData, pageSize, page] // Added page to dependencies
	);

	// Update the search effect to handle pagination
	useEffect(() => {
		if (searchQuery) {
			debouncedSearch(searchQuery);
		} else {
			fetchData();
		}
	}, [searchQuery, debouncedSearch, page]); // Added page to dependencies

	// Add this useEffect to monitor when job openings are available
	useEffect(() => {
		console.log(`Job openings state updated: ${allJobOpenings.length} items available`);
		if (allJobOpenings.length > 0) {
			console.log("Sample job openings:", allJobOpenings.slice(0, 3));
		}
	}, [allJobOpenings]);

	// Update useEffects to fetch job openings when filter button is clicked
	useEffect(() => {
		// Add this useEffect to load job openings when organization changes
		if (openFilterPopover) {
			fetchJobOpenings();
		}
	}, [openFilterPopover, fetchJobOpenings]);

	// Add function to handle job opening change
	const handleJobOpeningChange = (value) => {
		console.log("Job opening changed to:", value);
		setJobOpeningFilter(value);
	};

	return (
		<div className="timeline">
			<div style={{ margin: 10 }}>
				<Space style={{
					marginBottom: 16,
					justifyContent: 'flex-end',
					width: '100%',
					gap: '12px'
				}}>
					<Input
						placeholder="Search interviews..."
						value={searchQuery}
						onChange={(e) => setSearchQuery(e.target.value)}
						style={{
							width: '300px',
							height: '32px',
							marginRight: 'auto', // This pushes the search bar to the left
							borderRadius: '6px',
							border: '1px solid rgba(255, 255, 255, 1)',
							boxShadow: '0px 1px 2px 0px rgba(17, 24, 39, 0.08), 0px 0px 0px 1px rgba(17, 24, 39, 0.1)',
							backgroundColor: '#F3F4F6',
							fontSize: '14px',
							fontFamily: 'Inter',
							padding: '6px 10px',
						}}
						prefix={
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
								<circle cx="11" cy="11" r="8"></circle>
								<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
							</svg>
						}
					/>

					<button
						onClick={() => {
							fetchAllOrganizations();
							setOpenFilterPopover(true);
						}}
						style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '80px' }}
					>
						<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="155" height="32" viewBox="0 0 219 84">
							<image xlinkHref="data:image/png;base64,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" x="0" y="0" width="219" height="84" />
						</svg>
					</button>

					<Button
						icon={<img src={EmailReportIcon} alt="Send Email" style={{ width: '155px', height: '32px', marginRight: '100px' }} />}
						onClick={handleExportDialogOpen}
						style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
					>

					</Button>
				</Space>

				<div style={{
					overflowX: 'auto',
					width: '100%',
					maxWidth: '100%' // Ensure the container doesn't exceed page width
				}}>
					<Table
						columns={columns}
						dataSource={interviewList}
						filteredRoles={filteredRoles}
						rowKey="id"
						size="small"
						onRow={(record) => ({
							onClick: () => handleRowClick(record),
							style: { cursor: 'pointer' }
						})}
						pagination={false}
						// loading={isLoading}
						className="antTableClass"
						rowClassName={(record, index) => index % 2 === 0 ? 'custom-row' : ''}
						scroll={{ x: 3000 }}
					/>

					<div style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						padding: '16px 8px',
						background: 'rgba(238, 238, 240, 1)',
						borderTop: '0.5px solid rgba(218, 218, 221, 1)',
						borderRadius: '0 0 8px 8px',
						marginTop: '-10px'
					}}>
						<div style={{
							fontFamily: 'Inter',
							fontSize: '12px',
							fontWeight: 400,
							lineHeight: '18px',
							letterSpacing: '-0.1px',
							color: '#27272A'
						}}>
							Showing {Math.min(interviewList.length, pageSize)} of {totalItems} Interviews
						</div>

						<div style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
							margin: '0 auto'
						}}>
							{Array.from({ length: Math.ceil(totalItems / pageSize) }, (_, i) => i + 1).map((pageNum) => (
								<button
									key={pageNum}
									onClick={() => handlePageChange(pageNum)}
									style={{
										padding: '4px 8px',
										border: `1px solid ${page === pageNum ? '#1890ff' : '#d9d9d9'}`,
										borderRadius: '5px',
										background: page === pageNum ? '#f0f0f0' : 'white',
										cursor: 'pointer',
										color: '#666',
										fontSize: '12px',
										minWidth: '20px',
										display: pageNum === 1 ||
											pageNum === Math.ceil(totalItems / pageSize) ||
											(pageNum >= page - 1 && pageNum <= page + 1) ? 'block' : 'none'
									}}
								>
									{pageNum}
								</button>
							))}
							{page + 2 < Math.ceil(totalItems / pageSize) && (
								<span style={{ color: '#666' }}></span>
							)}
						</div>

						<div style={{ display: 'flex', alignItems: 'center' }}>
							<button
								onClick={() => handlePageChange(page - 1)}
								disabled={page <= 1}
								style={{
									fontFamily: 'Inter',
									fontSize: '12px',
									fontWeight: 400,
									lineHeight: '18px',
									letterSpacing: '-0.1px',
									color: page > 1 ? '#666' : '#ccc',
									cursor: page > 1 ? 'pointer' : 'not-allowed',
									marginRight: '0px',
									paddingRight: '16px',
									border: 'none',
									background: 'none'
								}}
							>
								← Previous
							</button>
							<div
								style={{
									borderLeft: '1px solid #d9d9d9',
									marginLeft: '8px',
									paddingLeft: '16px'
								}}
							>
								<button
									onClick={() => handlePageChange(page + 1)}
									disabled={page >= Math.ceil(totalItems / pageSize)}
									style={{
										fontFamily: 'Inter',
										fontSize: '12px',
										fontWeight: 400,
										lineHeight: '18px',
										letterSpacing: '-0.1px',
										color: page < Math.ceil(totalItems / pageSize) ? '#666' : '#ccc',
										cursor: page < Math.ceil(totalItems / pageSize) ? 'pointer' : 'not-allowed',
										border: 'none',
										background: 'none'
									}}
								>
									Next →
								</button>
							</div>
						</div>
					</div>
				</div>

				<Modal
					title="Filter Interviews"
					visible={openFilterPopover}
					onCancel={() => setOpenFilterPopover(false)}
					footer={null}
					width={410}
					style={{
						position: 'fixed',
						top: 0,
						right: 0,
						margin: 0,
						padding: 0
					}}
					bodyStyle={{ padding: 0 }}
					maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.45)' }}
					className="right-side-modal"
					closable={false}
				>
					{filterContent()}
				</Modal>

				<Modal
					title="Reschedule Interview"
					visible={openRescheduleDialog}
					onCancel={() => setOpenRescheduleDialog(false)}
					onOk={handleRescheduleSubmit}
					okText="Reschedule"
					cancelText="Cancel"
					width={600}
				>
					<Space direction="vertical" style={{ width: '100%' }}>
						{/* Loader while rescheduling */}
						{isRescheduling ? (
							<Spin tip="Rescheduling interview..." />
						) : (
							<>
								<div style={{ marginBottom: '8px', fontWeight: 'bold' }}>
									Reason for Rescheduling (Required)
								</div>
								<Input.TextArea
									placeholder="Enter reason for rescheduling"
									value={rescheduleReason}
									onChange={(e) => setRescheduleReason(e.target.value)}
									rows={4}
									style={{ 
										marginBottom: '16px',
										border: '1px solid #d9d9d9'
									}}
								/>
								
								<div style={{ marginBottom: '16px' }}>
									<Button 
										type="primary" 
										onClick={() => setShowQuestionSelector(!showQuestionSelector)}
										style={{ marginBottom: '8px' }}
									>
										{showQuestionSelector ? 'Hide Questions' : 'Select Questions for Rescheduled Interview'}
									</Button>
									
									{selectedQuestions.length > 0 && (
										<div style={{ 
											marginTop: '8px',
											padding: '8px',
											backgroundColor: '#f0f8ff',
											borderRadius: '4px',
											border: '1px solid #91d5ff'
										}}>
											<div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
												Selected {selectedQuestions.length} Questions
											</div>
											<div style={{ fontSize: '12px', color: '#666' }}>
												These questions will be included in the rescheduled interview
											</div>
										</div>
									)}
									
									{showQuestionSelector && (
										<div style={{ 
											border: '1px solid #d9d9d9', 
											borderRadius: '4px', 
											padding: '12px',
											maxHeight: '300px',
											overflowY: 'auto',
											marginTop: '8px'
										}}>
											<div style={{ marginBottom: '10px', fontWeight: 'bold' }}>
												Click on a question or checkbox to select/deselect
											</div>
											
											{isLoading ? (
												<div style={{ textAlign: 'center', padding: '20px' }}>
													<Spin tip="Loading questions..." />
												</div>
											) : availableQuestions.length > 0 ? (
												availableQuestions.map((question, idx) => (
													<div 
														key={idx} 
														style={{ 
															padding: '8px', 
															marginBottom: '8px',
															border: '1px solid #f0f0f0',
															borderRadius: '4px',
															backgroundColor: selectedQuestions.includes(question.index) ? '#f6ffed' : 'white',
															transition: 'background-color 0.2s' // Only transition background color for better performance
														}}
													>
														<div style={{ display: 'flex', alignItems: 'flex-start' }}>
															<Checkbox 
																checked={selectedQuestions.includes(question.index)}
																onChange={() => toggleQuestionSelection(question.index)}
																style={{ marginRight: '8px', marginTop: '4px' }}
															/>
															<div>
																<div style={{ fontWeight: 'bold' }}>Question {idx + 1}</div>
																<div>{question.question}</div>
															</div>
														</div>
													</div>
												))
											) : (
												<div>No questions available for this interview</div>
											)}
										</div>
									)}
								</div>
							</>
						)}
					</Space>
				</Modal>

				<Modal
					title="Export Interviews"
					visible={openExportDialog}
					onCancel={handleExportDialogClose}
					onOk={handleExportSubmit}
					okText="Export"
					cancelText="Cancel"
				>
					<Space direction="vertical" style={{ width: '100%' }}>
						<DatePicker
							value={exportData.start_date ? moment(exportData.start_date) : null}
							onChange={(date) => handleExportDataChange('start_date')(date ? date.format('YYYY-MM-DD') : '')}
							placeholder="Start Date"
							style={{ ...inputStyle, width: '100%' }}
						/>
						<DatePicker
							value={exportData.end_date ? moment(exportData.end_date) : null}
							onChange={(date) => handleExportDataChange('end_date')(date ? date.format('YYYY-MM-DD') : '')}
							placeholder="End Date"
							style={{ ...inputStyle, width: '100%' }}
						/>
						<Input
							type="time"
							placeholder="Start Time"
							value={exportData.start_time}
							onChange={(e) => handleExportDataChange('start_time')(e.target.value)}
							style={{ ...inputStyle, border: '1px solid #d9d9d9', width: '100%' }}
						/>
						<Input
							type="time"
							placeholder="End Time"
							value={exportData.end_time}
							onChange={(e) => handleExportDataChange('end_time')(e.target.value)}
							style={{ ...inputStyle, border: '1px solid #d9d9d9', width: '100%' }}
						/>
						
						
					</Space>
				</Modal>
			</div>

			<style jsx global>{`
				.timeline {
					overflow-x: hidden; /* Prevent horizontal scroll on the page */
					width: 100%;
				}
				.custom-pagination {
					display: flex;
					justify-content: center;
				}
				.custom-pagination .ant-pagination-item {
					border: 1px solid lightblue !important;
					margin: 0 4px;
				}
				.custom-pagination .ant-pagination-item-active {
					border: 1px solid lightblue !important;
					background-color: #f0f0f0 !important;
				}
				.custom-pagination .ant-pagination-item:focus,
				.custom-pagination .ant-pagination-item:hover {
					border: 1px solid lightblue !important;
				}
				.custom-pagination .ant-pagination-item a {
					color: #666 !important;
				}
				.custom-pagination .ant-pagination-prev,
				.custom-pagination .ant-pagination-next {
					display: none !important;
				}
				.custom-row {
					background-color: #f5f5f5;
				}
				.right-side-modal .ant-modal-content {
					height: 100vh;
					margin-right: 0;
					border-radius: 0;
					background: transparent;
				}
				
				.right-side-modal .ant-modal-body {
					height: 100%;
					padding: 0;
				}
				
				.right-side-modal .ant-modal-header {
					display: none;
				}
				
				/* Ensure the main container doesn't overflow */
				.timeline > div {
					max-width: 100%;
					box-sizing: border-box;
				}
				
				/* Make sure the table container is the only scrollable element */
				.antTableClass {
					width: 100%;
				}
			`}</style>
		</div>
	);
};

// Add this function outside the component or inside if you prefer
const renderQuestionCount = (count) => {
	if (count === undefined || count === null || count === -1) {
		return "N/A";
	}
	return count;
};

export default InterviewTimeline;
